import { createSelector } from 'reselect'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { selectCockpitDefaultMetric } from './selectCockpitDefaultMetric'
import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitMetric = createSelector(
  [selectFinancialCockpitState, selectCockpitDefaultMetric],
  ({ selectedMetric }, defaultMetric) => {
    const validTypes = Object.values(ActualsValueTypes).filter(
      (type) => type !== ActualsValueTypes.None
    )

    return validTypes.find((type) => type === selectedMetric) ?? defaultMetric
  }
)
